/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeviceType } from './DeviceType'
import type { ProjectLabelArray } from './ProjectLabelArray'
import type { SiteArray } from './SiteArray'
import type { TrackingType } from './TrackingType'
export type Configuration = {
  subscription_active?: boolean
  custom_design_enabled: boolean
  logo: string | null
  company_name: string
  company_id: number
  device_id: number
  user_id: number | null
  custom_color: string | null
  tracking_type?: TrackingType
  tracking_interval_seconds?: number | null
  device_name?: string | null
  type: DeviceType
  company_mode: Configuration.company_mode | null
  employee_list_mode?: Configuration.employee_list_mode | null
  push_token_expired?: boolean
  sites: SiteArray
  project_labels?: ProjectLabelArray
  amplitude_api_key?: string | null
  ki_features_enabled: boolean
  correction_reason_enabled: boolean
  travel_log_enabled: boolean
  daily_notes_enabled: boolean
  clocki_enabled: boolean
  ai_translations_enabled: boolean
  nfc_auth_enabled: boolean
  vacation_seconds_enabled: boolean
  project_videos_enabled: boolean
  shift_plans_enabled: boolean
}
export namespace Configuration {
  export enum company_mode {
    LIGHT = 'light',
    ATTENDANCE = 'attendance',
    PROJECT = 'project',
    DOCUMENTATION = 'documentation',
  }
  export enum employee_list_mode {
    HIDDEN = 'hidden',
    NO_ACTIVITY = 'no_activity',
    FULL = 'full',
    NFC = 'nfc',
  }
}
